import image from '@/assets/consultant/scott-shemwell.jpg'
import type { Consultant } from '@/types/consultant'

export const consultants: Consultant[] = [
  {
    name: 'Dr. Scott M. Shemwell',
    credentials: 'D.B.A.',
    role: 'Strategic Consultant',
    image,
    bio: [
      'Dr. Scott M. Shemwell, Managing Director of The Rapid Response Institute, is an authority and thought leader in artificial intelligence, field operations, and risk management, with over 35 years in the energy sector leading turnaround and transformation processes for global S&P 500 organisations as well as start-up and professional service firms.',
      'He has been directly involved in over $5 billion in acquisitions and divestitures, as well as the management of significant global projects and multiple business units, and has led the use of data and information technology enabling Operational Excellence for over three decades.',
      'He is a published expert on cross-cultural business interactions, and during the post-Deepwater Horizon period served with an American Petroleum Institute group to help develop industry specifications for Safety and Environmental Management Systems and Culture of Safety.',
    ],
    highlights: [
      { value: '35+', label: 'Years in Energy & Transformation' },
      { value: '$5B+', label: 'In Acquisitions & Divestitures' },
      { value: '14', label: 'Books Published' },
      { value: '$100M+', label: 'International Projects Sold' },
    ],
    publications: [
      {
        year: 'Forthcoming 2027',
        title: 'The AI Advantage: Strategic Implementation for Sustainable Business Transformation',
      },
      {
        year: '2026',
        title:
          'Nonlinear Big Data and AI-Enabled Problem-Solving: Transforming from a Spreadsheet Society',
      },
      {
        year: '2025',
        title: "Navigating the Data Minefields: Management's Guide to Better Decision-Making",
      },
      {
        year: '2023',
        title:
          'Smart Manufacturing: Integrating Transformational Technologies for Competitiveness and Sustainability',
      },
    ],
    linkedin: 'https://www.linkedin.com/in/scottsh',
  },
]
